import { MaterialIconName } from '@gorila-shared-ui/components';
import { Asset } from './asset';
import { GeoPolygon } from './geoModels';
import { MediaCore } from './media';
import { NotificationOrigin } from './notificationConfig';

export interface NotificationCore {
  _id: string;
  created: number;
  notificationType: number;
  title: string;
  read: boolean;
  label?: string;
  licensePlate?: string;
  vin?: string;
  ident?: string;
  brand?: string;
  subBrand?: string;
  origin?: NotificationOrigin;
  actions?: {
    [K in NotificationActions]: NotificationAction;
  };
}

export interface Notification extends NotificationCore {
  latitude: number;
  longitude: number;
  timestamp: number;
  asset?: Asset;
  extraData?: {
    fenceId?: string;
    polygon: GeoPolygon;
    encodedPolygon?: string;
  };
}

export interface PusherNotification extends NotificationCore {
  id?: string;
  client?: string;
  subClient?: string;
  subAccount?: string;
  eventType: string;
  playSound: boolean;
  showBubble: boolean;
}

export interface NotificationType {
  _id: string;
  notificationId: number;
  name: string;
  isEvent: boolean;
}

export interface NotificationTypeItem {
  name: string;
  notificationId: number;
  origin: NotificationOrigin;
}

export enum NotificationActions {
  viewDetails = 'viewDetails',
}

export enum NotificationLinkableSection {
  requestVideo = 'request-video',
  alarmEvidences = 'alarm-evidences',
}

export interface RequestVideoParams {
  assetId: string;
  ident: string;
}

export interface NotificationEvidence extends MediaCore {
  id: string;
}

export interface AlarmEvidencesParams {
  alarmId: string;
  evidences: NotificationEvidence[];
}

export interface NotificationActionCore {
  title: string;
  icon: MaterialIconName;
  blank: boolean;
}

export type NotificationAction =
  | (NotificationActionCore & {
      section: NotificationLinkableSection.requestVideo;
      params: RequestVideoParams;
    })
  | (NotificationActionCore & {
      section: NotificationLinkableSection.alarmEvidences;
      params: AlarmEvidencesParams;
    });
